module.exports = __webpack_public_path__ + "static/img/10.6d7a4de.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/shop/10.jpg
// module id = al3Y
// module chunks = 0